module.exports = __webpack_public_path__ + "img/Narnia.56e32e05.svg";